<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <div class="btn-group-one">
            <el-button type="primary" size="small" @click="addQueueNumber"
              >排队取号</el-button
            >
            <el-button type="primary" size="small" @click="openQueueLink" plain
              >排号显屏</el-button
            >
          </div>
          <div class="btn-group-two">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="allChecked"
              label="全选"
              border
              @change="checkAllChange"
              size="small"
            ></el-checkbox>
            <el-button
              plain
              :disabled="!checkedLineUpList.length ? true : false"
              size="small"
              @click="printAll"
              >手动打号</el-button
            >
          </div>
        </div>
      </div>
      <div class="tab-content">
        <!-- <el-tooltip content="Top center" placement="top"> -->
        <el-tabs v-model="lineUpTypeActive" type="card">
          <el-tab-pane
            v-for="(item, index) in lineUpTypeList"
            :key="String(item.shoppingTableConfigId)"
            :label="`${item.tableConfigName}(空桌${item.emptyNumber}桌)`"
            :value="index"
          ></el-tab-pane>
        </el-tabs>
        <!-- </el-tooltip> -->
        <div class="list" v-loading="isLoading">
          <el-checkbox-group
            v-model="checkedLineUpList"
            @change="checkedLineUpChange"
          >
            <el-table :data="lineUpList" style="width: 100%;">
              <el-table-column label="排号">
                <template slot-scope="scope">
                  <el-checkbox :label="scope.row.id">
                    <div>
                      排号<span class="line-code">{{
                        scope.row.lineCode
                      }}</span>
                    </div>
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                prop="phoneNumber"
                label="手机号"
              ></el-table-column>
              <el-table-column label="预估等位">
                <template slot-scope="scope">
                  {{ scope.row.waitingTime }}分钟
                </template>
              </el-table-column>
              <el-table-column label="已叫号">
                <template slot-scope="scope">
                  {{ scope.row.callTimes }}次
                </template>
              </el-table-column>
              <el-table-column label="操作" header-align="right" width="400">
                <template slot-scope="scope">
                  <div class="float-right">
                    <el-button
                      size="small"
                      type="primary"
                      @click="callLineUp(scope.row.id, scope.row.lineCode)"
                      >叫号</el-button
                    >
                    <el-button
                      size="small"
                      type="primary"
                      @click="jumpLineUp(scope.row.id)"
                      plain
                      >过号</el-button
                    >
                    <el-button
                      size="small"
                      plain
                      @click="getLineUpById(scope.row.id, scope.$index)"
                      >手动打号</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogQueueVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">排队取号</div>
      <el-form
        :model="queueNumberForm"
        :rules="queueNumberFormRule"
        ref="queueNumberForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input
            v-model="queueNumberForm.phoneNumber"
            :maxlength="15"
            placeholder="请输入手机号"
          ></el-input>
          <div class="text-red">
            <i class="el-icon-warning-outline"></i>
            等待时间仅供参考
          </div>
        </el-form-item>
        <el-form-item label="餐桌类型">
          <el-radio-group v-model="queueNumberForm.shoppingTableConfigId">
            <div
              class="radio-block"
              v-for="item in lineUpTypeList"
              :key="item.shoppingTableConfigId"
            >
              <el-radio :label="item.shoppingTableConfigId"
                ><span class="radio-left"
                  >{{ item.tableConfigName }}({{ item.min }}-{{ item.max }}人)
                </span>
                <span class="radio-right"
                  >前方<span class="text-red">{{ item.lineUpNumber }}</span
                  >桌（预计{{
                    item.lineUpNumber * item.waitingTime
                  }}分钟）</span
                ></el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createQueueNumber" :loading="isSubmit"
          >确定取号</el-button
        >
        <el-button @click="dialogQueueVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLineUpType,
  getLineUpList,
  addLineUp,
  callLineUp,
  jumpLineUp,
  getLineUpById,
  getPrintRules,
} from "@/api";
import { getLodop } from "@/utils/LodopFuncs.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      checkedLineUpList: [],
      lineUpTypeList: [],
      lineUpTypeActive: 0,
      lineUpList: [],
      dialogQueueVisible: false,
      queueNumberForm: {
        phoneNumber: "",
        shoppingTableConfigId: 0,
      },
      queueNumberFormRule: {
        phoneNumber: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
      isSel: false,
      allChecked: false,
      isIndeterminate: false,
      isLoading: false,
      printDeviceId: "",
    };
  },
  mounted() {
    this.getPageData();
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    lineUpListOptions() {
      let options = [];
      this.lineUpList.forEach((val) => {
        options.push(val.id);
      });
      return options;
    },
  },
  watch: {
    lineUpTypeActive(val) {
      this.isLoading = true;
      this.resetCheckedState();
      if (!this.lineUpTypeList.length) {
        return;
      }
      this.getLineUpList(this.lineUpTypeList[val].shoppingTableConfigId);
    },
  },
  methods: {
    getPageData() {
      this.getLineUpType();
      getPrintRules({
        pageNo: 1,
        row: 5,
        printType: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.printDeviceId = res.data[0].printDevices;
        }
        if (res.code == -1) {
          this.$notify({
            title: "提示",
            message: "请去往小票设置-普通小票,配置打印机",
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getLineUpType() {
      getLineUpType().then((res) => {
        if (res.code == 1) {
          this.lineUpTypeList = res.data;
        } else {
          this.lineUpTypeList = [];
        }
        this.getLineUpList(
          this.lineUpTypeList[this.lineUpTypeActive].shoppingTableConfigId
        );
      });
    },
    getLineUpList(id) {
      getLineUpList({
        shoppingTableConfigId: id,
      }).then((res) => {
        if (res.code == 1) {
          this.lineUpList = res.data;
        } else {
          this.lineUpList = [];
        }
        this.isLoading = false;
      });
    },
    addQueueNumber() {
      this.queueNumberForm = {
        phoneNumber: "",
        shoppingTableConfigId: 0,
      };
      this.queueNumberForm.shoppingTableConfigId = this.lineUpTypeList[0].shoppingTableConfigId;
      this.dialogQueueVisible = true;
    },
    addLineUp(params, index) {
      this.isSubmit = true;
      addLineUp(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "取号成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.dialogQueueVisible = false;
          this.getLineUpById(res.data.id, index);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.isSubmit = false;
        }, 500);
      });
    },
    createQueueNumber() {
      this.$refs.queueNumberForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.queueNumberForm));
          this.addLineUp(params, this.lineUpList.length + 1);
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetCheckedState() {
      this.allChecked = false;
      this.isIndeterminate = false;
      this.isSel = false;
      this.checkedLineUpList = [];
    },
    checkAllChange(val) {
      this.checkedLineUpList = val ? this.lineUpListOptions : [];
      this.isIndeterminate = false;
      this.isSel = val;
      this.allChecked = val;
    },
    checkedLineUpChange(value) {
      let checkedCount = value.length;
      this.allChecked = checkedCount === this.lineUpList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.lineUpList.length;
      this.isSel = checkedCount > 0;
    },
    callLineUp(id, lineCode) {
      callLineUp({
        lineUpId: id,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "叫号成功",
            type: "success",
            duration: 2000,
          });
          this.playSound(lineCode);
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    jumpLineUp(id) {
      jumpLineUp({
        lineUpId: id,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "过号成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    printAll() {
      this.checkedLineUpList.forEach((val, index) => {
        setTimeout(() => {
          this.getLineUpById(val, index);
        }, 500);
      });
    },
    getLineUpById(id, index) {
      getLineUpById({
        lineUpId: id,
      }).then((res) => {
        if (res.code == 1) {
          console.log(res);
          let template_html = `<div style="text-align:center;font-size: 18px">
                                            ${this.shop.shopName}排队小票
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            您的排队号码: ${res.data.lineCode}
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            您之前有: ${index}位客人
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            ${res.data.createTime}
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            您选择的客位类型：${
                                              res.data.tableConfigName
                                            }
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            ------------------------------------------
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            过期过号请重新取号到等待区等待呼叫
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            餐厅名称：${this.shop.shopName}
                                        </div>
                                        <div style="text-align:left;font-size: 12px;">
                                            电话：${this.shop.shopTel}
                                        </div>
                                        `;
          LODOP = getLodop();
          if (!LODOP) {
            if (confirm("打印机连接失败,查看解决方案？")) {
              window.location.href = basePath + "print/tip.html";
            } else {
              return;
            }
          }
          LODOP.PRINT_INIT("订单小票");
          LODOP.ADD_PRINT_HTM(0, 10, "100%", "100%", template_html);
          LODOP.SET_PRINT_COPIES(1); //设置打印份数
          LODOP.SET_PRINT_PAGESIZE(3, 80 * 10, 40, "");
          // LODOP.PREVIEW();
          LODOP.SET_PRINTER_INDEXA(this.printDeviceId);
          LODOP.PRINT();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    openQueueLink() {
      window.open(
        `https://www.madiancan.com/mdcClassify/index.html?userId=${
          localStorage["userId"]
        }`
      );
    },
    playSound(lineCode) {
      let lineCodeArr = lineCode.split("");
      lineCodeArr.forEach((val, index) => {
        setTimeout(() => {
          let mp3 = require(`../../public/audio/tts_g1_${String(
            val
          ).toLocaleLowerCase()}.mp3`);
          let audio = new Audio(mp3);
          audio.play();
        }, index * 500);
        if (index == lineCodeArr.length - 1) {
          setTimeout(() => {
            let mp3 = require(`../../public/audio/tts_g1_hao.mp3`);
            let audio = new Audio(mp3);
            audio.play();
            setTimeout(() => {
              let mp3 = require(`../../public/audio/tts_g1_qing.mp3`);
              let audio = new Audio(mp3);
              audio.play();
            }, 500);
          }, lineCodeArr.length * 500);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    .btn-group-two {
      .el-checkbox {
        margin-right: 15px;
      }
    }
  }
  .tab-content {
    display: block;
    padding: 20px;
    .line-code {
      color: #409eff;
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .radio-block {
    margin: 10px 0;
    .radio-left {
      display: inline-block;
      min-width: 120px;
      max-width: 220px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .radio-right {
    }
  }
  .text-red {
    color: #f56c6c;
  }
}
// /deep/.el-tabs__item {
//     width: 120px;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
// }
</style>
